import { useContext, useState } from "react";

import { Grid } from "@material-ui/core";
import {
  InputOptionMaster,
  InputTextArea,
  InputTextMaster,
  MasterButton,
} from "App/Component/ui";
import { FormContext } from "../../context/FormContext";
import { TYPE_INSTANCE4 } from "App/constants";
import { useSelectOption } from "App/hooks";
import DatePicker from "react-datepicker";
import moment from "moment";
import { isNull } from "App/utils/helpers";
import { FORM_RESET_STATE_WMS_MT } from "../../helpers";
import { STATUS_PENGERJAAN_PENGAJUAN } from "../../../HelpDesk/helpers";
import ModalSimpan from "../ModalSimpan/ModalSimpan";
import { SearchIcon } from "App/Assets";
import ModalListHD from "./ModalListHD";
export default function FormMT({ setNewDataReqList }) {
  const { formData, setFormData } = useContext(FormContext);
  const [showModalSimpan, setShowModalSimpan] = useState(false);
  const [showModalListHD, setShowModalListHD] = useState(false);
  const [rowsSelect, setRowsSelect] = useState([]);


  const handleClickSelect = async (row) => {
    setFormData({
      ...formData,
      id_helpdesk_header: row.id,
      unit_id: row?.unit_id,
      unit: row?.unit,
      gudang: row?.gudang,
      gudang_id: row?.gudang_id,
    });
    setShowModalListHD(false);
  };

  const unit = useSelectOption(
    true,
    "/wmsmaster/unit/read_gudang_farmasi",
    TYPE_INSTANCE4
  );

  const gudang = useSelectOption(
    true,
    "/wmsMasterAsset/gudang/list",
    TYPE_INSTANCE4,
    "gudangId",
    "name"
  );

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  const handleReset = () => {
    setFormData(FORM_RESET_STATE_WMS_MT);
  };

  // const changeSelectWithLocalStorage = (e, name_id, name_label) => {
  //   setFormData({
  //     ...formData,
  //     [name_id]: e?.value,
  //     [name_label]: e?.label,
  //   });
  // };

  // useEffect(() => {
  //   setFormData({
  //     ...formData,
  //     date: moment(new Date()).local().toDate(),
  //   });
  // }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const vendor = useSelectOption(
    true,
    "/wmsMasterAsset/vendor/list",
    TYPE_INSTANCE4
  );

  return (
    <>
      {showModalSimpan && (
        <ModalSimpan
          setShowModal={() => setShowModalSimpan(false)}
          resetForm={() => handleReset()}
          setNewDataReqList={setNewDataReqList}
          rowsSelect={rowsSelect}
        />
      )}
      {showModalListHD && (
        <ModalListHD
          setShowModal={() => setShowModalListHD(false)}
          handleClickSelect={handleClickSelect}
          onlySelect={false}
          rowsSelect={rowsSelect}
          setRowsSelect={setRowsSelect}
        />
      )}
      <form action="">
        <Grid container spacing={1}>
          <Grid item sm={8}>
            <Grid container spacing={1}>
              <Grid item sm={3}>
                {isNull(formData.id) ? (
                  <InputTextMaster
                    name="id"
                    label=" ID Maintenance / ID Help Desk"
                    id="id"
                    placeholder={"Cari Request"}
                    disabled={true}
                    value={
                      formData?.id_helpdesk_header
                        ? formData?.id_helpdesk_header+" ( "+rowsSelect.length+" Asset Terpilih)"
                        : formData.id
                    }
                    withButton={true}
                  >
                    <button
                      type={"button"}
                      onClick={() => setShowModalListHD(!showModalListHD)}
                      style={{
                        borderRight: "1px solid #EAEAEA",
                        borderTop: "1px solid #EAEAEA",
                        borderBottom: "1px solid #EAEAEA",
                        borderLeft: "0",
                        background: "#fff",
                        padding: "0 0.8rem",
                        cursor: "pointer",
                        borderRadius: "0 6px 6px 0",
                      }}
                    >
                      <SearchIcon width={"16"} height={"16"} fill={"#333"} />
                    </button>
                  </InputTextMaster>
                ) : (
                  <InputTextMaster
                    name="id"
                    label=" ID Maintenance / ID Help Desk"
                    id="id"
                    value={
                      isNull(formData.id)
                        ? formData.id_helpdesk_header
                        : formData.id
                    }
                    placeholder={"-"}
                    disabled={true}
                    withButton={false}
                  />
                )}{" "}
              </Grid>
              <Grid item sm={3}>
                <InputTextMaster
                  name="user"
                  label="USERNAME REQUEST"
                  id="user"
                  disabled={true}
                  value={formData?.user_request}
                  placeholder="UserName Request"
                  onChange={handleChange("user_request")}
                />
              </Grid>
              <Grid item sm={3}>
                <InputOptionMaster
                  name="id_unit"
                  label="UNIT"
                  id="id_unit"
                  disabled={
                    formData.status_service >= STATUS_PENGERJAAN_PENGAJUAN
                      ? true
                      : false
                  }
                  withSearch={true}
                  value={formData.unit_id}
                  labelValue={formData.unit}
                  onChange={(e) => {
                    if (isNull(e)) {
                      setFormData({
                        ...formData,
                        id_unit: null,
                        unit: "Pilih Unit",
                      });
                    } else {
                      setFormData({
                        ...formData,
                        unit_id: e.value,
                        unit: e.label,
                      });
                    }
                  }}
                  data={unit}
                  error={true}
                />
              </Grid>
              <Grid item sm={3}>
                <InputOptionMaster
                  name="gudang_id"
                  label="GUDANG FIXED ASSET"
                  id="gudang_id"
                  withSearch={true}
                  data={gudang}
                  disabled={
                    formData.status_service >= STATUS_PENGERJAAN_PENGAJUAN
                      ? true
                      : false
                  }
                  value={formData.gudang_id}
                  labelValue={formData.gudang}
                  onChange={(e) => {
                    if (isNull(e)) {
                      setFormData({
                        ...formData,
                        gudang_id: null,
                        gudang: "Pilih Gudang",
                      });
                    } else {
                      setFormData({
                        ...formData,
                        gudang_id: e?.value,
                        gudang: e?.label,
                      });
                    }
                  }}
                />
              </Grid>

              <Grid item sm={4}>
                <InputOptionMaster
                  name="vendor"
                  label="VENDOR"
                  id="vendor"
                  value={formData.vendor_id}
                  labelValue={formData.vendor}
                  withSearch={true}
                  onChange={(e) =>
                    isNull(e)
                      ? setFormData({
                          ...formData,
                          vendor_id: "",
                          vendor: "Pilih Vendor",
                        })
                      : setFormData({
                          ...formData,
                          vendor_id: e?.value,
                          vendor: e?.label,
                        })
                  }
                  data={vendor}
                  disabled={
                    formData.status_service >= STATUS_PENGERJAAN_PENGAJUAN
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid item sm={4}>
                <InputTextMaster
                  name="pic"
                  label="PIC"
                  id="pic"
                  value={formData.pic}
                  onChange={handleChange("pic")}
                  placeholder="PIC"
                  disabled={
                    formData.status_service >= STATUS_PENGERJAAN_PENGAJUAN
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid item sm={4}>
                <div
                  style={{
                    marginTop: "0.5rem",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <label htmlFor="date" className="form-control-label">
                    TANGGAL
                  </label>

                  <div
                    onClick={() =>
                      setFormData({
                        ...formData,
                        date: moment(new Date()).local().toDate(),
                      })
                    }
                    style={{
                      fontSize: "10px",
                      color: "#3399ff",
                      cursor: "pointer",
                    }}
                  >
                    Today
                  </div>
                </div>
                <DatePicker
                  id="date"
                  autoComplete="off"
                  className="form-control text"
                  dateFormat="dd/MM/yyyy HH:mm"
                  timeFormat="HH:mm"
                  showTimeSelect
                  timeIntervals={5}
                  locale="id-ID"
                  selected={moment(formData.taggal_request).toDate()}
                  disabled={
                    formData.status_service >= STATUS_PENGERJAAN_PENGAJUAN
                      ? true
                      : false
                  }
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      taggal_request: e,
                    });
                  }}
                  placeholderText="Tanggal"
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item sm={4}>
            <InputTextArea
              name="remark"
              disabled={
                formData.status_service >= STATUS_PENGERJAAN_PENGAJUAN
                  ? true
                  : false
              }
              label="CATATAN"
              id="remark"
              placeholder="Catatan"
              rows={6}
              value={formData.remark}
              onChange={handleChange("remark")}
            />
          </Grid>
          <Grid item sm={12}>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <MasterButton
                className={"mt-1"}
                type="button"
                color={"danger"}
                outline={true}
                name={"RESET"}
                onClick={() => handleReset()}
                size="md"
              />

              <div>
                <MasterButton
                  type={"button"}
                  color="green"
                  name="Simpan"
                  size="lg"
                  onClick={() => setShowModalSimpan(!showModalSimpan)}
                />
              </div>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
